import { render, staticRenderFns } from "./PropertyTransactionHistory.vue?vue&type=template&id=da9daa04&"
import script from "./PropertyTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./PropertyTransactionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports